module.exports = __webpack_public_path__ + "static/media/settings.d688120c.svg";